export enum Events {
  ShowNotification = 'show_notification',
  Loading = "loading",
  ValidateStart = "validate_start",
  ValidateStop = "validate_stop"
}